// 无人机飞行参数设置
export default {
    ET: '设备类型',
    PSDT: '请选择设备类型',
    RP: '读取参数',
    WP: '写入参数',
    SP: '保存参数',
    OP: '打开参数',
    NS: '请输入无人机名称/SN',
    ND: '暂无数据',
    FP: '飞行参数',
    CUPN: '当前使用参数名称',
    CUPT: '当前使用参数类型',
    explain: '说明',
    control: '控制',
    value: '值',
    RCS: '遥控器感度',
    PS: '姿态感度',
    PN: '参数名称',
    PD: '参数说明',
    PF: '参数文件',
    TIME: '时间',
    AVL: '角速度环',
    AR: '角度环',
    HR: '高度环',
    PR: '位置环',
    AA: '高度加速度',
    AV: '高度速度',
    altitude: '高度',
    PS1: '位置速度',
    position: '位置',
    MAJ: '加加速度最大值',
    TCSOS: '打杆瞬间姿态相应快慢',
    MinA: '加速度最小值',
    TMAAV: '定点模式下打杆或者刹车时可允许的最小的加速度值。效果为：小杆量动作跟随快慢',
    MaxA: '加速度最大值',
    TMAAV2: '定点模式下打杆或者刹车时可允许的最大的加速度值。效果为：大杆量动作跟随快慢',
    MaxS: '速度最大值',
    MAS: '允许的速度最大值',
    MSORC: '遥控器速度最大值',
    MARCS: '允许的遥控器控制速度最大值',
    VF: '速度滤波器',
    AFASF: '速度滤波截止频率改小后飞机变肉（未开启）',
    ACF: '加速度控制标志位',
    ACHT: '加速度控制悬停时间',
    MAV: '加速度方差最大值',
    tip_PCOV: '请勾选一架无人机',
    tip_PSDT: '请选择设备类型',
    tip_PCTU: '请勾选无人机',
    tip_TPCUA: '当前使用的参数与机型不一致，强行写入存在安全风险 是否写入?',
    tip_DP: '删除参数',
    tip_PEPR: '参数错误，请重新输入',
    tip_PSE: '参数设置错误',
    tip_UTRAD: '删除之后无法恢复, 是否继续?',
}